import { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from '../contexts/userContext';

export default function Logout() {
  const { setLoginStatus } = useContext(UserContext);

  const history = useHistory();
  useEffect(() => {
    setLoginStatus(false);
    history.push('/machineSignIn');
    localStorage.clear();
  }, []);

  return null;
}
